import React from "react";
import { motion, AnimatePresence } from "framer-motion";

// Extracted motion configs — module-level constants avoid re-allocating identical
// objects on every render, which prevents unnecessary work in framer-motion.
const MENU_INITIAL = { opacity: 0, height: 0 };
const MENU_ANIMATE = { opacity: 1, height: "auto" };
const MENU_EXIT = { opacity: 0, height: 0 };
const MENU_TRANSITION = { duration: 0.25 };

const resolveHref = (item, pathname) => {
  if (item.route) return item.href;
  return pathname !== "/" ? "/" + item.href : item.href;
};

export default function MobileMenu({ open, items, locationPathname, onItemClick, onCtaClick }) {
  if (!open) return null;
  return (
    <AnimatePresence>
      <motion.div
        key="mob"
        initial={MENU_INITIAL}
        animate={MENU_ANIMATE}
        exit={MENU_EXIT}
        transition={MENU_TRANSITION}
        className="lg:hidden overflow-hidden border-t border-[var(--mn-line)] bg-white"
        data-testid="mobile-menu"
      >
        <div className="mn-container py-6 flex flex-col gap-1">
          {items.map((item) => (
            <a
              key={item.href}
              href={resolveHref(item, locationPathname)}
              className="py-3 border-b border-[var(--mn-line)] text-[var(--mn-black)] font-medium tracking-wide uppercase text-sm hover:text-[var(--mn-gold)]"
              onClick={(e) => onItemClick(e, item)}
              data-testid={`mob-nav-${item.label.toLowerCase()}`}
            >
              {item.label}
            </a>
          ))}
          {onCtaClick && (
            <button
              type="button"
              onClick={onCtaClick}
              className="btn-mn-primary mt-4"
              data-testid="mob-cta-quote"
            >
              Solicitar Orçamento
            </button>
          )}
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
